let init = {
}

export default (state = init, action) => {
  switch (action.type) {
    default:
      return state
  }
}